var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15Z",
    fill: "#D42216"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9C13.6744 9.00147 12.4035 9.49863 11.4662 10.3824C10.5289 11.2662 10.0016 12.4644 10 13.7143C9.99842 14.7357 10.3523 15.7293 11.0073 16.5429C11.0073 16.5429 11.1436 16.7121 11.1659 16.7366L15 21L18.8359 16.7344C18.8559 16.7117 18.9927 16.5429 18.9927 16.5429L18.9932 16.5416C19.6479 15.7284 20.0016 14.7352 20 13.7143C19.9984 12.4644 19.4711 11.2662 18.5338 10.3824C17.5965 9.49863 16.3256 9.00147 15 9ZM15 15.4286C14.6404 15.4286 14.2889 15.328 13.9899 15.1397C13.6909 14.9513 13.4578 14.6836 13.3202 14.3703C13.1826 14.0571 13.1466 13.7124 13.2168 13.3798C13.2869 13.0473 13.4601 12.7418 13.7144 12.5021C13.9686 12.2624 14.2926 12.0991 14.6453 12.0329C14.998 11.9668 15.3636 12.0007 15.6958 12.1305C16.028 12.2602 16.312 12.48 16.5118 12.7619C16.7115 13.0438 16.8182 13.3752 16.8182 13.7143C16.8176 14.1688 16.6258 14.6045 16.285 14.9258C15.9441 15.2472 15.482 15.428 15 15.4286Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationImg);
export default __webpack_public_path__ + "static/media/LocationImg.26e334c0257d171d1d96fb8ee3ef257f.svg";
export { ForwardRef as ReactComponent };